import Dispatch from '../Dispatch/Dispatch';

function triggerDispatch(attr) {
	switch(attr) {
	case 'selectedCountry':
		Dispatch.dispatch.call('selectedCountryUpdate');
		break;

	case 'hoveredCountry':
		Dispatch.dispatch.call('hoveredCountryUpdate');
		break;

	case 'hoveredRegion':
		Dispatch.dispatch.call('hoveredRegionUpdate');
		break;

	default:
		break;
	}
}


var api = {
	hoveredCountry: null,
	selectedCountry: null,
	hoveredRegion: null,

	set: function(attr, value) {
		api[attr] = value;

		triggerDispatch(attr);
	}
};

export default api;




/** WEBPACK FOOTER **
 ** ./src/State/State.js
 **/